export const DEV_KIT_AUTH_OVERRIDE_LOCALSTORAGE_KEY = 'DEV_KIT_AUTH_OVERRIDE_LOCALSTORAGE_KEY';
